import Person from './Person'

class LegalPerson extends Person {
    constructor(
        id,
        type,
        businessName,
        singleTaxIdentification,
        displayName,
        streetName,
        streetNumber,
        flat,
        floor,
        interactions,
        contacts,
        name,
        email,
        phoneType,
        phoneNumber,
        locality,
        countMultiQuotes,
        countPolicies,
        broker,
        sellerName,
        notes,
        hasLoan,
        loanNumber,
        loanExpirationDate,
    ) {
        super(
            id,
            type,
            locality,
            displayName,
            email,
            phoneType,
            phoneNumber,
            countMultiQuotes,
            countPolicies
        )
        this.businessName = businessName
        this.singleTaxIdentification = singleTaxIdentification
        this.streetName = streetName
        this.streetNumber = streetNumber
        this.flat = flat
        this.floor = floor
        this.interactions = interactions
        this.name = name
        this.contacts = contacts
        this.broker = broker
        this.sellerName = sellerName
        this.dni = singleTaxIdentification
        this.notes = notes
        this.hasLoan = hasLoan
        this.loanNumber = loanNumber
        this.loanExpirationDate = loanExpirationDate
    }

    static fromJson({
        id,
        type,
        businessName,
        singleTaxIdentification,
        displayName,
        streetName,
        streetNumber,
        flat,
        floor,
        interactions,
        contacts = [],
        locality,
        countMultiQuotes,
        countPolicies,
        broker,
        sellerName,
        notes,
        hasLoan,
        loanNumber,
        loanExpirationDate,
    }) {
        const [contact] = contacts
        const name = contact?.name
        const mail = contact?.mail
        const email = contact?.email
        const phoneType = contact?.phoneType
        const phoneNumber = contact?.phoneNumber
        return new LegalPerson(
            id,
            type,
            businessName,
            singleTaxIdentification,
            displayName,
            streetName,
            streetNumber,
            flat,
            floor,
            interactions,
            contacts,
            name,
            email || mail,
            phoneType,
            phoneNumber,
            locality,
            countMultiQuotes,
            countPolicies,
            broker,
            sellerName,
            notes,
            hasLoan,
            loanNumber,
            loanExpirationDate,
        )
    }
}

export default LegalPerson
